module.exports = __webpack_public_path__ + "img/icon-expand-vertical.d1d61c54.svg";